<template>
    <div style="display: flex; flex-direction: column;">
        <div style="border-bottom: 1px solid #f5f5f5;">
            <MercenaryHeader :closeAction="back" :back-title="'뒤로가기'" :title="noticeType === NOTICE_TYPE.EVENT ? '이벤트' : '공지사항'"></MercenaryHeader>
        </div>
        <InfinityScroll :refresh-action="refresh" :handleNextPage="handleNextPage" :isEnableNextPageHandle="isEnableNextPageHandle" style="flex: 1; overflow: hidden;">
            <div style="padding: 0 12px; padding-top: 8px; overflow-y: scroll; height: 100%;">
                <div @click="showNotificationDetail(each.idx)" style="padding: 12px 0; border-bottom: 1px solid #f5f5f5;" v-for="each, i in list" :key="i">
                    <div style="font-weight: 500; line-height: 24px; margin-bottom: 8px;">{{ each.title }}</div>
                    <div style="font-weight: 500; font-size: 14px; color: #808080; line-height: 24px;">{{ each.notice_date }}</div>
                </div>
            </div>
        </InfinityScroll>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import InfinityScroll from '@/components/common/InfinityScroll'
import { NOTICE_TYPE } from '@/Constants'

export default {
    name: "Notification",
    components: {MercenaryHeader, InfinityScroll},
    data() {
        return {
            list: [
            ],
            isEnableNextPageHandle: true,
            page: 1,
            NOTICE_TYPE: NOTICE_TYPE
        }
    },
    props: {
        noticeType: {
            type: String,
            default: '',
        }
    },
    methods: {
        back() {
            this.$GlobalStore.closeLastModal()
        },
        async getNotification() {
            this.isEnableNextPageHandle = false
            const parameters = {};
            parameters.page = this.page;
            parameters.notice_type = this.noticeType === NOTICE_TYPE.EVENT ? '이벤트' : '공지사항'
            const res = await this.$Axios.get('/api/notice', { params: parameters });
            const list = res.data.noticeList;

            if (list.length > 0) {
                this.list = [...this.list, ...list];
                this.isEnableNextPageHandle = true;
            }
        },
        handleNextPage() {
            this.page++;
            this.getNotification();
        },
        refresh() {
            this.isEnableNextPageHandle = true;
            this.list = [];
            this.page = 1;
            this.getNotification();
        },
        showNotificationDetail(idx) {
            this.$GlobalStore.addModal('NoticeDetail', { notice_idx: idx, isClickOutside: true })
        }
    },
    created() {
        this.getNotification();
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

h2,
h3,
h4,
p,
ul {
    margin: 0;
    padding: 0;
    list-style: none;
    margin-block: 0;
    margin-inline: 0;
}

a {
    display: inline-block;
    text-decoration: none;
    color: #101014;
}

h2 {
    font-size: 24px;
    font-weight: 500;
    line-height: 35px;
    padding: 18px 20px 10px 20px;
    box-sizing: border-box;
}

h3 {
    font-size: 20px;
    line-height: 29px;
    font-weight: 500;
    display: inline-block;
}

input {
    outline: none;
}

input[type=number]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

[notification] {
    overflow: hidden;
}

.top-cont {
    width: 100%;
    background: #fff;
    z-index: 1;
}

.dim {
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.3s;
    animation-timing-function: ease-out;
}

section {
    position: relative;
}

.content-detail {
    padding: 30px 12px;
    box-sizing: border-box;
}

.top-btns {
    height: 60px;
    border-bottom: 1px solid;
    border-color: #F5F5F5;
    padding-top: 7px;
    box-sizing: border-box;
    text-align: center;
}

.top-btns h2 {
    padding: 0;
    display: inline-block;
    border-bottom: none;
    line-height: 53px;
}

.top-btns a.back {
    font-size: 0;
    width: 65px;
    height: 53px;
    position: absolute;
    left: 0;
    top: 7px;
}

.top-btns a.back:after {
    content: '';
    width: 25px;
    height: 29px;
    background: url("~@/assets/images/mypage/ico-back.png")0 0 no-repeat;
    background-size: contain;
    position: absolute;
    left: 20px;
    top: 12px;
}

ul li {
    padding: 12px 45px 12px 20px;
    box-sizing: border-box;
    border-radius: 15px;
    box-shadow: 0 5px 10px 0 rgba(16, 16, 20, 0.2);
    margin-bottom: 20px;
    position: relative;
}

ul li:after {
    content: '';
    width: 13px;
    height: 23px;
    background: url("~@/assets/images/mypage/ico-arrow.png")0 0 no-repeat;
    background-size: contain;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
}

ul li .date {
    font-size: 14px;
    color: #888;
    line-height: 20px;
    margin-bottom: 15px;
}

ul li .tit {
    font-size: 16px;
    line-height: 23px;
}

ul li a {
    font-size: 0;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}


.dimOpen .dim {
    opacity: 0.5;
    z-index: 5;
}
</style>